import { Easing, interpolate } from 'remotion';

// Constants
import { CLAMP_BOTH } from '@/constants';
import {
  SCENE5B_COLORS,
  SCENE5B_FONTS,
  SCENE5B_LAYOUT,
  SCENE5B_REVEAL_FRAME_RANGE,
} from '../../constants';

interface TrainingTitleProps {
  titleText: string;
  titleFontSize: number;
  frame: number;
}

export const TrainingTitle = ({
  titleText,
  titleFontSize,
  frame,
}: TrainingTitleProps) => {
  const { title, card } = SCENE5B_LAYOUT;
  const titleLineHeight = titleFontSize * title.lineHeightRatio;

  const progress = Easing.out(Easing.cubic)(
    interpolate(frame, SCENE5B_REVEAL_FRAME_RANGE, [0, 1], CLAMP_BOTH),
  );

  // Distance from card bottom to final position
  const revealDistance = Math.max(
    0,
    card.height - title.topInCard - titleLineHeight,
  );

  // Animate slide-up from revealDistance to 0
  const translateY = interpolate(
    progress,
    [0, 1],
    [revealDistance, 0],
    CLAMP_BOTH,
  );

  // Animate clip-path top from 100% to 0%
  const clipTop = interpolate(progress, [0, 1], [100, 0], CLAMP_BOTH);

  return (
    <div className="absolute z-[3] overflow-hidden" style={SCENE5B_LAYOUT.card}>
      <div
        className="absolute flex-center overflow-hidden"
        style={{
          top: title.topInCard,
          left: title.leftInCard,
          paddingLeft: title.paddingLeft,
          color: SCENE5B_COLORS.textTitle,
          ...SCENE5B_FONTS.title,
          fontSize: titleFontSize,
          lineHeight: `${titleLineHeight}px`,
          transform: `translateY(${translateY}px)`,
          clipPath: `inset(${clipTop}% 0% 0% 0%)`,
          width: title.safeAreaWidth,
          height: title.safeAreaHeight,
        }}
      >
        <p className="w-full break-words">{titleText}</p>
      </div>
    </div>
  );
};
